import React from 'react';
import ReactDOM from 'react-dom';
import NavigationMenu_TopHeader from "../../components/top-header/top-header";
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {QuickAddItemType} from "../../../../app/quick-add/@types";
import NavigationMenuItemUrl from "../../menu-items/menu-item-url";
import NavigationMenuSection from "../../menu-items/section/section";
import NavigationMenuAdd from "../../menu-items/menu-add/menu-add";
import ModalReportSelect from "../../../../app/project/reports/modal/modal-report-select";
import Report from "../../../../core/model2/report/report";
import ApiProject from "../../../../core/gd/api/project";
import {SpaceReports} from "../../../../core/model2/space/system/reports";
import ProjectSession from "../../../../core/model2/project/project-session";
import NavigationMenu_ItemReport from "../../menu-items/report/menu-item-report";
import MainMenu_SectionReorderableWithMore from "../../components/menu-controller/menu-section-reordable-with-more";
import {BUS_TREE_CHANGE} from "../../../../core/gd/bus/bus-event-type"
import ArrayUtils from "../../../../core/gd/utils/array";

type State = {
    reRender             : boolean
}

export default class MainMenu_Reports extends React.Component<MenuComponentProps, State> {

    private animationDelay  : any
    private animShow        : boolean = false
    private spaceReports    : SpaceReports

    constructor(props:MenuComponentProps) {
        super(props);
        this.spaceReports = new SpaceReports();

        this.state = {
            reRender: false
        };
    }

    componentDidMount() {

        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 25);
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
    }

    reRender = ()=> {
        this.setState({
            reRender: true
        });
    }

    onAddUserClick = (e:React.SyntheticEvent) => {
        if (e) e.stopPropagation();
        // this.hidePopover();
        gd.openNew(QuickAddItemType.USER, {
            type            : 'invite-user',
            organizationId  : gd.companyId
        })
    }

    sessionDataChanged = () => {
        this.forceUpdate()
    }

    onClickNew = ()=> {
        gd.modal.showV4({
            className       : 'modal-new-version-released',
            component       : ModalReportSelect,
            params          : {
                onSubmit    : async (report: Report)=>{
                    gd.modal.hide()

                    try {
                        const response = await ApiProject.newReportView({
                            name            : report.name,
                            projectIcon     : "report",
                            properties      : {customViewType  : report.type},
                            settings        : {
                                customView      : {
                                    settings        : report.settings,
                                    type            : report.type
                                }
                            }
                        }).promise()

                        gd.navigation.goToProject(response.projectId, "")

                    } catch (e) {
                        console.error(e)
                    }
                }
            }
        });
    }

    onReorderEnd = (items:any) => {
        gd.user.menu.myReports.sortPositions = items.map((item:any)=>item.id);
        gd.user.menu.save();
    };

    render() {

        // has to be company user + to access this section
        if (!gd.ac.check.company.isUser(gd.companyId)) {
            return null
        }

        const classes = Classes('main-menu-container menu-people ui5-menu p-t-0',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        const components: any[] = _.map(this.spaceReports.reports, (report: ProjectSession, key: number)=>({
            item        : report,
            component   : <NavigationMenu_ItemReport key        = {key}
                                                     level      = {0}
                                                     dndPreview = {false}
                                                     report     = {report}/>
        }))

        const menuItems = _(components)
            .orderBy([
                component=>ArrayUtils.indexOrder(gd.user.menu.myReports.sortPositions, component.item.id), // try to order by sort position
            ], ['asc'])
            .value();

        return (
            <div className={classes}>

                <NavigationMenu_TopHeader space={gd.spaces.reports}/>

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>
                    <NavigationMenuSection collapsible={false} systemName="reports-top">

                        <NavigationMenuItemUrl name                 = "All Reports"
                                               icon                 = "i5-chart-bar"
                                               url                  = {'o/analytics'}
                                               navigationSection    = {gd.spaces.reports.navigation}/>

                        <NavigationMenuItemUrl name                 = "Saved Reports"
                                               icon                 = "i5-pie-chart"
                                               url                  = {"o/reports/saved"}
                                               navigationSection    = {gd.spaces.reports.navigation} />

                    </NavigationMenuSection>


                    <NavigationMenuSection name         = "My Reports"
                                           collapsible  = {true}
                                           counter      = {menuItems.length}
                                           systemName   = "my-reports">

                        <MainMenu_SectionReorderableWithMore countVisibleItems  = {8}
                                                             moreTitle          = "All Reports"
                                                             newItemTitle       = "New Report"
                                                             components         = {menuItems}
                                                             settingsKey        = "reports-reports"
                                                             showAdd            = {false}
                                                             onReorderEnd       = {this.onReorderEnd}/>

                        <NavigationMenuAdd name="New Report" onClick={this.onClickNew}/>

                    </NavigationMenuSection>
                </VScroll>
            </div>
        );
    }
}
